"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReaderResourceResponseModelResourceType = void 0;
exports.ReaderResourceResponseModelResourceType = {
    Read: "read",
    Collection: "collection",
};
